import React from 'react'
import { Checkbox as MuiCheckbox} from '@material-ui/core'

const Checkbox = ({...props}) => <MuiCheckbox {...props}/>

export default Checkbox
